import { copy } from '../../copy/investor-copy'

const LARGEST_PLAN = 'STANDARD_100'

/** The plan as the follow cards name it; an unknown plan is shown as it comes. */
export function planName(plan: string): string {
  switch (plan) {
    case 'FREE':
      return copy('card.plan.free')
    case 'STANDARD_25':
      return copy('card.plan.standard_25')
    case 'STANDARD_100':
      return copy('card.plan.standard_100')
    case 'FOUNDING':
      return copy('card.plan.founding')
    default:
      return plan
  }
}

/** On the largest plan there is no bigger one to choose, so the card offers no "See plans". */
export const isLargestPlan = (plan: string): boolean => plan === LARGEST_PLAN
